<template>
  <div class="layout-wrap">
    <div class="nav-wrap">
      <div class="nav-logo" @click="handleLogoClick">
        <img src="@/assets/images/logo.png" alt="">
      </div>
      <div class="nav-menu">
        <ul>
          <li @click="handleHome" :class="{'active': isActive === 'homeActive'}">
            <p>首页</p>
          </li>
          <li @mouseout="handleMeunOut" @mouseover="handleMeunOver" :class="{'active': isActive === 'newActive'}">
            <p>{{blockName}}</p>
            <div class="meun-list" v-show="meunShow">
              <div class="meun-item" v-for="item in consultantList" :key="item.id"  @click="handleNewsClick(item)">
                <i class="el-icon-notebook-2"></i>
                <span>{{item.blockName}}</span>
              </div>
              <div class=""></div>
            </div>
          </li>
          <li @mouseout="handleOrganizationOut" @mouseover="handleOrganizationOver">
            <p>测试者登录 <i class="el-icon-arrow-down"></i></p>
            <organization class="organization" @handleChangeCity="handleChangeCity" v-show="isShowOrganization" :orgList="orgList" @jump="jump"/>
          </li>
          <!-- <li @click="handleOrgReg">
            <p>机构注册</p>
          </li> -->
          <li v-if="isLogin" @click="handlePlannerHome" :class="{'active': isActive === 'plannerActive'}">
            <p>咨询师主页</p>
          </li>
          <!-- <li @click="handleLogin" v-else>
            <p>咨询师登录</p>
          </li> -->
          <!-- <li @click="handlePlaReg">
            <p>咨询师注册</p>
          </li> -->
          <li @mouseout="handleRegOut" @mouseover="handleRegOver">
            <p>注册 <i class="el-icon-arrow-down"></i></p>
            <div class="meun-list" v-show="reg">
              <div class="meun-item">
                <span style="display:block; margin: 0 auto;" @click="handlePlaReg">咨询师注册</span>
              </div>
              <div class="meun-item">
                <span style="display:block; margin: 0 auto;"  @click="handleOrgReg">机构注册</span>
              </div>
            </div>
          </li>
          <li @mouseout="handleAdministratorOut" @mouseover="handleAdministratorOver">
            <p>登录 <i class="el-icon-arrow-down"></i></p>
            <div class="meun-list" v-show="Administrator">
              <div class="meun-item">
                <span style="display:block; margin: 0 auto;" @click="handleHoutai('zongpingtai')">总平台登录</span>
              </div>
              <div class="meun-item">
                <span style="display:block; margin: 0 auto;" @click="handleLogin">咨询师登录</span>
              </div>
              <div class="meun-item">
                <span style="display:block; margin: 0 auto;" @click="handleHoutai('jigou')">机构登录</span>
              </div>
            </div>
          </li>
          <li @mouseout="handleCityOut" @mouseover="handleCityOver" class="city-wrap">
            <p>{{currentCity}}
              <!-- <i class="el-icon-arrow-down"></i> -->
            </p>
            <!-- <p>{{currentCity}} <i class="el-icon-arrow-down"></i></p>
            <city class="city"
              v-show="isShowCity"
              :currentCity="currentCity"
              @handleChangeCity="handleChangeCity"
            /> -->
          </li>
        </ul>
      </div>
    </div>
    <myselect :selectShow="selectShow" @handleClose="handleClose"></myselect>
    <!-- <keep-alive> -->
      <router-view></router-view>
    <!-- </keep-alive> -->
    <!-- <div class="register-banner">
      <div class="w">
        <p>立即注册，即可免费试听云课中心课程，开启您的0门槛上云之旅！</p>
        <div @click="handleOrgReg">立即注册</div>
      </div>
    </div> -->
    <div class="footer-wrap">
      <div class="w">
        <div class="footer-top">
          <div class="footer-item">
            <img class="icon" src="@/assets/images/icon.png" alt="">
            <div>
              <p>电话：</p>
              <p>010-81761826</p>
              <!-- <p>15095170893</p> -->
            </div>
          </div>
          <div class="footer-item">
            <img class="www" src="@/assets/images/www.png" alt="">
            <div>
              <p>网址：</p>
              <p style="cursor: pointer;" @click="jumpXinlicloud">www.xinlicloud.com</p>
            </div>
          </div>
          <div class="footer-item">
            <img class="dizhi" src="@/assets/images/dizhi.png" alt="">
            <div>
              <p>地址：</p>
              <p>北京市昌平区宏福科技园宏福大厦</p>
              <!-- <p>山东省潍坊市诸城市经济开发区</p> -->
            </div>
          </div>
        </div>
        <div class="footer-bottom"> <span @click="jumpBeian">京ICP备20012024号</span> 北京学能通科技集团有限公司版权所有</div>
      </div>
    </div>
    <div class="right-nav">
      <ul>
        <li>
          <div class="r-n-item">
            <i class="font-icon iconfont icon-erweima erweima"></i>
          </div>
          <div class="tel-wrap">
            <div class="code-wrap">
              <div class="code">
                <img src="@/assets/images/code.jpg" alt="">
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="r-n-item">
            <i class="font-icon el-icon-phone-outline"></i>
          </div>
          <div class="tel-wrap">
            <p>电话：<br/>010-81761826</p>
            <!-- <p>电话：<br/>15095170893</p> -->
          </div>
        </li>
        <li @click="backtop" v-show="isShowTopBtn">
          <div class="r-n-item">
            <i class="font-icon el-icon-upload2"></i>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import http from '@/http/index'
import myselect from '@/components/select'
import city from './city'
import organization from './organization'
import {mapState, mapMutations} from 'vuex'
export default {
  data () {
    return {
      isShowTopBtn: false,
      blockName: '',
      consultantList: [],
      meunShow: false,
      selectShow: false,
      Administrator: false,
      isShowCity: false,
      isShowOrganization: false,
      orgList: [], // 机构列表
      reg:false,
    }
  },
  computed: {
    ...mapState(['isLogin', 'isActive', 'currentCity'])
  },
  created () {
    this.params = {
      level: '1'
    }
    this.getBlockNames(this.params)
    this.getCity()
  },
  mounted () {
    window.addEventListener('scroll', this.showbtn, true)
  },
  methods: {
    ...mapMutations(['handleCurrentCity']),
    jumpBeian () {
      window.open('https://beian.miit.gov.cn/')
    },
    jumpXinlicloud () {
      window.open(' https://www.xinlicloud.com')
    },
    handleChangeCity (city) {
      if (!city) return
      this.isShowCity = false
      this.getOrgInfoByCity(city)
    },
    // 根据城市来请求机构列表
    getOrgInfoByCity (city) {
      const cityData = {
        city
      }
      http.getOrgInfoByCity(cityData).then(res => {
        this.orgList = res.data.data
      })
    },
    handleCityOut () {
      this.isShowCity = false
    },
    handleCityOver () {
      this.isShowCity = true
    },
    handleRegOut () {
      this.reg = false
    },
     handleRegOver () {
      this.reg = true
    },
    getCity () {
      const self = this
      AMap.plugin('AMap.Geolocation', function () {
        var geolocation = new AMap.Geolocation({
          // 是否使用高精度定位，默认：true
          enableHighAccuracy: true,
          // 设置定位超时时间，默认：无穷大
          timeout: 10000
        })
        geolocation.getCurrentPosition()
        AMap.event.addListener(geolocation, 'complete', onComplete)
        AMap.event.addListener(geolocation, 'error', onError)

        function onComplete (data) {
          // data是具体的定位信息
          self.getLngLatLocation()
        }

        function onError (data) {
          // 定位出错
          console.log('定位失败错误：', data)
        }
      })
    },
    getLngLatLocation () {
      AMap.plugin('AMap.CitySearch', () => {
        var citySearch = new AMap.CitySearch()
        citySearch.getLocalCity((status, result) => {
          if (status === 'complete' && result.info === 'OK') {
            // 查询成功，result即为当前所在城市信息
            const city = result.city
            this.handleCurrentCity(city)
            this.getOrgInfoByCity(city)
            // 逆向地理编码
            AMap.plugin('AMap.Geocoder', () => {
              var geocoder = new AMap.Geocoder({
                // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
                city: result.adcode
              })
              var lnglat = result.rectangle.split(';')[0].split(',')

              geocoder.getAddress(lnglat, (status, data) => {
                if (status === 'complete' && data.info === 'OK') {
                  // result为对应的地理位置详细信息
                }
              })
            })
          }
        })
      })
    },
    showbtn () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 500) {
        this.isShowTopBtn = true
      } else {
        this.isShowTopBtn = false
      }
    },
    backtop () {
      var timer = setInterval(() => {
        let osTop = document.documentElement.scrollTop || document.body.scrollTop
        let ispeed = Math.floor(-osTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed
        this.isTop = true
        if (osTop === 0) {
          clearInterval(timer)
        }
      }, 20)
    },
    handleOrganizationSelect () {
      this.selectShow = true
      document.body.style.overflow = 'hidden'
    },
    handleClose () {
      this.selectShow = false
      document.body.style.overflow = ''
    },
    handleOrganizationOut () {
      this.isShowOrganization = false
    },
    handleOrganizationOver () {
      this.isShowOrganization = true
    },
    jump () {
      this.isShowOrganization = false
    },
    handleLogin () {
      this.$router.push({
        path: '/login'
      })
    },
    handleHome () {
      this.$store.state.isActive = 'homeActive'
      this.$router.push({
        path: '/'
      })
    },
    handlePlannerHome () {
      this.$store.state.isActive = 'plannerActive'
      this.$router.push({
        path: '/planner'
      })
    },
    handleOrgReg () {
      this.$router.push({
        path: '/registerOrg'
      })
    },
    handlePlaReg () {
      this.$router.push({
        path: '/registerPlanner'
      })
    },
    handleLogoClick () {
      this.$router.push({
        name: 'layout'
      })
    },
    getBlockNames (parems) {
      http.getBlockNames(parems).then(res => {
        let contents = ''
        if (res.data.data && Array.isArray(res.data.data)) {
          contents = res.data.data[0]
        }
        return contents
      }).then(res => {
        this.blockName = res.blockName
        this.acquireFirstPortalConsultTitleList(res.id)
      })
    },
    acquireFirstPortalConsultTitleList (id) {
      http.acquireFirstPortalConsultTitleList({blockType: id}).then(res => {
        this.consultantList = res.data.data
      })
    },
    handleMeunOut () {
      this.meunShow = false
    },
    handleMeunOver () {
      this.meunShow = true
    },
    handleAdministratorOut () {
      this.Administrator = false
    },
    handleAdministratorOver () {
      this.Administrator = true
    },
    handleNewsClick (item) {
      this.$store.state.isActive = 'newActive'
      this.$router.push({
        name: 'news',
        params: {
          blockId: item.id
        }
      })
    },
    handleHoutai (type) {
      if (type === 'zongpingtai') {
        window.open('https://sys.xinlicloud.com')
      } else if (type === 'jigou') {
        window.open('https://org.xinlicloud.com')
      }
    }
  },
  components: {
    myselect,
    city,
    organization
  }
}
</script>

<style lang="scss" scoped>
  @import '../assets/css/sass/variable.sass';
  .layout-wrap {
    width: 100%;
    .nav-wrap {
      width: 1200px;
      height: 85px;
      margin: 0 auto;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .nav-logo {
        width: 210px;
        height: 80px;
        cursor: pointer;
        img {
          width: 150px;
          height: 40px;
          margin-top: 17px;
        }
      }
      .nav-menu {
        ul{
          display: flex;
          justify-content: center;
          li {
            padding:0 16px;
            color: $el-main-color;
            cursor: pointer;
            p {
              line-height: 85px;
            }
            &.active {
              color: #FF8B00;
            }
            &:hover {
              color: #FF8B00;
              position: relative;
            }
            .meun-list {
              width: 166px;
              border-radius: 5px;
              background: #fff;
              position:absolute;
              top: 82px;
              left: 50%;
              margin-left: -83px;
              z-index: 10;
              .meun-item {
                height:40px;
                display: flex;
                align-items: center;
                font-size: 14px;
                color: #666;
                border-bottom:1px solid #eee;
                &:last-child {
                  border:none;
                }
                &:hover {
                  color: #FF8B00;
                }
                i{
                  margin:2px 16px 0 22px;
                  font-size: 20px;
                  display: block;
                }
                span{
                  line-height:0;
                }
              }
            }
          }
          .city-wrap:hover {
            position:static;
          }
        }
      }
      .city {
        width: 1200px;
        height: 600px;
        background: #fff;
        position:absolute;
        top: 85px;
        left: 50%;
        margin-left: -600px;
        box-shadow: 0px 10px 10px rgba(0,0,0,.3);
        z-index: 100;
      }
      .organization {
        width: 1200px;
        height: 850px;
        background: #fff;
        position:absolute;
        top: 85px;
        left: 50%;
        margin-left: -655px;
        box-shadow: 0px 10px 10px rgba(0,0,0,.3);
        z-index: 100;
      }
    }
    .register-banner {
      height: 120px;
      background: url('~@/assets/images/regBg.png') no-repeat;
      background-size: cover;
      .w {
        width: $el-center;
        margin: 0 auto;
        overflow: hidden;
        p {
          font-size: 18px;
          font-weight: bold;
          color: #FFFFFF;
          margin: 25px 0 14px;
        }
        div {
          width: 160px;
          height: 40px;
          background: #E39712;
          border-radius: 5px;
          text-align: center;
          line-height: 40px;
          color:#fff;
          cursor: pointer;
        }
      }
    }
    .footer-wrap {
      height: 120px;
      background: url(../assets/images/footer.png) no-repeat center;
      background-size: cover;
      color: #fff;
      overflow: hidden;
      .w {
        width: $el-center;
        margin: 0 auto;
        overflow: hidden;
      }
      .footer-top {
        margin: 25px 0 0 0;
        display: flex;
        justify-content: space-between;
        .footer-item{
          display: flex;
          font-size: 14px;
          .icon{
            width: 11px;
            height: 18px;
            margin-right: 20px;
            margin-top: 4px;
          }
          .www{
            width: 16px;
            height: 16px;
            margin-right: 20px;
            margin-top: 4px;
          }
          .dizhi {
            width: 17px;
            height: 18px;
            margin-right: 20px;
            margin-top: 4px;
          }
          .footer-icon{
            display: block;
            margin-top: 4px;
            margin-right: 20px;
            font-size: 20px;
          }
        }
      }
      .footer-bottom {
        text-align: center;
        font-size: 14px;
        margin-top:30px;
        span {
          cursor: pointer;
        }
      }
    }
    .right-nav {
      position:fixed;
      right: 80px;
      bottom: 100px;
      ul {
        li {
          width: 74px;
          height: 74px;
          border-radius: 50%;
          position: relative;
          background: #fff;
          box-shadow: 0px 0px 20px rgba(0,0,0,.3);
          margin-bottom: 20px;
          .r-n-item {
            line-height: 74px;
            text-align: center;
            font-size: 30px;
            color:#666666;
            cursor: pointer;
            .erweima {
              font-size: 30px;
              color:#666666;
            }
          }
          .tel-wrap {
            // width: 200px;
            padding: 20px 20px;
            background: #fff;
            box-shadow: 0px 0px 20px rgba(0,0,0,.3);
            border-radius: 5px;
            position: absolute;
            top: 50%;
            transform: translate(0, -50%);
            font-size: 16px;
            display: none;
            opacity: 0;
            right: 50%;
            .code-wrap {
              display: flex;
              text-align: center;
              .code {
                margin: 0 10px;
                img {
                  width: 150px;
                  height: 150px;
                }
                p {
                  font-size: 14px;
                  color: #878A9C;
                }
              }
            }
            p {
              white-space:nowrap;
            }
          }
          &:hover {
            .tel-wrap {
              right: 110%;
              opacity: 1;
              display: block;
              transition: opacity .3s;
            }
            .font-icon {
              color: $el-main-color;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/layout.vue